export default __webpack_public_path__ + "0c7e3c7beabd8c9a9e0a378a326c5d6c.png";